export default {
  methods: {
    newLineCodeToBr(str){
      return str.replace(/\r?\n/g, "<br>");
    }
  }
};
